﻿import {
    ValgStateActionTypes,
    TOGGLE_VILKAR,
    ToggleVilkarAction,
    ValgState,
    UPDATE_VALG,
    TOGGLE_UTBETALING,
    ToogleUtbetalingAction,
} from './Types';

import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { ForelopigUttalelseSkjemaSideAppState } from '..';
import { AnyAction } from 'redux';
import { setVisning } from '../Resultat/Actions';
import {ja, nei} from '../../Models/Values';

export const updateVisning = (): ThunkAction<void, ForelopigUttalelseSkjemaSideAppState, {}, AnyAction> => {
    return (
        dispatch: ThunkDispatch<ForelopigUttalelseSkjemaSideAppState, {}, AnyAction>,
        getState: () => ForelopigUttalelseSkjemaSideAppState,
    ): void => {
        const currentState = getState();
        const visSteg2 = visS2(currentState);
        const visSteg3 = visS3(currentState);
        const visSteg4a = visS4a(currentState);
        const visSteg4b = visS4b(currentState);
        const visSteg5 = visS5(currentState);
        dispatch(
            setVisning({  
                visSteg2,
                visSteg3,
                visSteg4a,
                visSteg4b,
                visSteg5
            }),
        );
    };
};

export function updateValg(newValg: Partial<ValgState>): ValgStateActionTypes {
    return {
        type: UPDATE_VALG,
        payload: newValg,
    };
}

export function toggleUtbetaling(): ToogleUtbetalingAction {
    return {
        type: TOGGLE_UTBETALING,
    };
}

export function toggleVilkar(): ToggleVilkarAction {
    return {
        type: TOGGLE_VILKAR,
    };
}

const visS2 = (state: ForelopigUttalelseSkjemaSideAppState): boolean => {
    return state.valg.brukerInfo !== undefined;
};

const visS3 = (state: ForelopigUttalelseSkjemaSideAppState): boolean => {
    if(state.valg.utdanning !== undefined) 
        return true;
    else 
        return false;
};

const visS4a = (state: ForelopigUttalelseSkjemaSideAppState): boolean => {
    if(state.valg.land !== undefined && state.valg.utdanning?.value === ja) 
        return true;
    else 
        return false;
};

const visS4b = (state: ForelopigUttalelseSkjemaSideAppState): boolean => {
    if(state.valg.land !== undefined && state.valg.utdanning?.value === nei) 
        return true;
    else 
        return false;
};

const visS5 = (state: ForelopigUttalelseSkjemaSideAppState): boolean => {
    if(state.valg.periode !== undefined) 
        return true;
    else 
        return false;
};
